import { useDrawDqDataBaseStore } from "../hooks/useDrawDqDataBaseStore"
import { DrawDqData } from "./drawDqData";

export const DrawDqDataContainer = () => {
  const { drawDqDataBaseStore } = useDrawDqDataBaseStore();
  return (
    <DrawDqData store={drawDqDataBaseStore} />
  )
}